import React from 'react';
import { COMPANY, STATS } from '../../data/siteData';
import Button from '../common/Button';

export default function HeroSection() {
  return (
    <>
      <section id="home" style={{
        minHeight: '100vh',
        display: 'flex', flexDirection: 'column',
        justifyContent: 'center', alignItems: 'center',
        textAlign: 'center',
        padding: '100px 20px 60px',
        position: 'relative', overflow: 'hidden',
        width: '100%',
      }}>
        <div style={{
          position: 'absolute', inset: 0,
          background: 'radial-gradient(ellipse 600px 400px at 50% 45%, rgba(201,168,76,0.07) 0%, transparent 70%)',
          pointerEvents: 'none',
        }} />

        <div style={{
          display: 'inline-flex', alignItems: 'center', gap: '8px',
          background: 'rgba(201,168,76,0.08)',
          border: '1px solid rgba(201,168,76,0.2)',
          borderRadius: '100px', padding: '6px 16px',
          fontSize: '10px', color: 'var(--gold)',
          letterSpacing: '0.1em', textTransform: 'uppercase',
          marginBottom: '24px', position: 'relative', zIndex: 1,
        }}>
          <span style={{ width: 5, height: 5, background: 'var(--gold)', borderRadius: '50%', display: 'inline-block', flexShrink: 0 }} />
          Registered LLC · {COMPANY.domain}
        </div>

        <h1 style={{
          fontFamily: 'var(--font-serif)',
          fontSize: 'clamp(32px, 8vw, 86px)',
          fontWeight: 700, lineHeight: 1.08,
          maxWidth: '780px', position: 'relative',
          marginBottom: '16px', zIndex: 1,
          width: '100%',
        }}>
          Wealth Built on{' '}
          <em style={{ color: 'var(--gold)', fontStyle: 'normal' }}>Precision.</em>
        </h1>

        <p style={{
          fontSize: 'clamp(13px, 3.5vw, 17px)',
          color: 'var(--text-secondary)',
          maxWidth: '520px', lineHeight: 1.75,
          margin: '0 0 36px', fontWeight: 300,
          position: 'relative', zIndex: 1,
          width: '100%',
        }}>
          {COMPANY.subTagline}
        </p>

        <div className="hero-btns">
          <Button variant="primary" href="#contact">Start Investing</Button>
          <Button variant="outline" href="#services">Our Services</Button>
          <Button variant="outline" href="https://calendly.com/pmg-info/30min"
            style={{ borderColor: 'rgba(201,168,76,0.5)', color: 'var(--gold)' }}>
            📅 Book a Call
          </Button>
        </div>
      </section>

      {/* Stats */}
      <div className="stats-grid">
        {STATS.map((stat, i) => (
          <div key={i} className="stat-item">
            <div className="stat-num">{stat.value}</div>
            <div className="stat-label">{stat.label}</div>
          </div>
        ))}
      </div>
    </>
  );
}
